module.exports = __webpack_public_path__ + "static/media/icon_arrow_down_light.a5d6a965.svg";